<div class="ft-tooltip-menu" *ngIf="isVisible">
    <ng-container [ngTemplateOutlet]="tooltip" />
    <ng-content select="[tooltip]" />
</div>
<div (click)="show(); $event.stopPropagation()">
    <ng-content select="[trigger]" />
</div>